import { getPriceIndex, getPriceChart } from "@/api/panel";
import { Chart } from "@/utils/charts";

function renderPriceList(data) {
  return {
    ...data,
    bqPriceIndex: {
      ...data.bqPriceIndex,
      yoyMsrp: data.bqPriceIndex.yoyMsrp || { key: "-", value: "" },
      yoyTp: data.bqPriceIndex.yoyTp || { key: "-", value: "" },
    },
    tqPriceIndex: {
      ...data.tqPriceIndex,
      yoyMsrp: data.tqPriceIndex.yoyMsrp || { key: "-", value: "" },
      yoyTp: data.tqPriceIndex.yoyTp || { key: "-", value: "" },
    },
  };
}

export default {
  namespaced: true,
  state: {
    options: {},
    priceList: {
      bqPriceIndex: {
        tp: "",
        msrp: "",
        discount: "",
      },
      tqPriceIndex: {
        tp: "",
        msrp: "",
        discount: "",
      },
    },
  },
  mutations: {
    SET_PRICE_INDEX: (state, data) => {
      state.priceList = data;
    },
    SET_PRICE_CHART: (state, data) => {
      state.options = data;
    },
  },
  actions: {
    getPriceIndex({ commit, state }) {
      if (state.priceList.bqPriceIndex.tp) return;
      getPriceIndex({}).then((response) => {
        const { data } = response.data || {};
        this.priceList = data || [];
        if (data) commit("SET_PRICE_INDEX", renderPriceList(data || {}));
      });
    },

    getPriceChart({ commit, state }) {
      if (Object.keys(state.options).length > 0) return;
      getPriceChart().then((response) => {
        const { data } = response.data || {};
        const options = new Chart("bar", data || [], {
          color: ["#06D6A0", "#D3DEFF", "#5F87FF"],
          barMaxWidth: 10,
          barGap: 0,
          grid: {
            left: 20,
            right: 20,
            top: 65,
            bottom: 32,
          },
          legend: {
            itemWidth: 8,
            itemHeight: 8,
            top: 10,
          },
          yAxis: [
            {
              name: "",
              axisLabel: {
                show: false,
              },
              min: (value) => value.max - (value.max - value.min) * 2.5,
              max: (value) => value.max,
            },
            {
              name: "",
              axisLabel: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              max: (value) => value.max * 2.2,
            },
          ],
          field: {
            type: "percent",
          },
        }).getChart();
        commit("SET_PRICE_CHART", options);
      });
    },
  },
};
